import React from 'react';

export default (cellData) => (
  <div style={ { height: 20, width: 20, backgroundColor: cellData } } />
);
